import "./index.css";
import React from "react";
import Copy from "./Copy";
import { Avatar, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";

import ICON_PEN from "../../assets/pen.svg";
import ICON_PHONE from "../../assets/phone.svg";
import ICON_EMAIL from "../../assets/email.svg";
import ICON_DELETE from "../../assets/delete.svg";

import type { MenuProps } from "antd/lib";
import type { TypeLenderContactPerson } from "../../hooks/useContact";

export interface TypeItemProps extends TypeLenderContactPerson {
  onClick?(type: "UPDATE" | "DELETE", user: TypeLenderContactPerson): void;
}

const Item: React.FC<TypeItemProps> = ({ onClick, ...user }) => {
  const onItemClick: MenuProps["onClick"] = (e) => {
    onClick?.(e.key as Parameters<TypeItemProps["onClick"]>[0], user);
  };

  return (
    <div className="scenario-contact-item">
      <div>
        <Avatar>
          {user.first_name?.[0]}
          {user.last_name?.[0]}
        </Avatar>
      </div>
      <div className="scenario-contact-item-info">
        <p>
          <span>
            {user.first_name} {user.last_name}
          </span>
          {onClick ? (
            <Dropdown
              trigger={["click"]}
              rootClassName="scenario-contact-item-dropdown"
              menu={{
                onClick: onItemClick,
                items: [
                  {
                    key: "UPDATE",
                    label: "Edit contact",
                    icon: <img width={20} src={ICON_PEN} />,
                  },
                  {
                    key: "DELETE",
                    label: (
                      <span style={{ color: "#AB291C" }}>Delete contact</span>
                    ),
                    icon: <img width={20} src={ICON_DELETE} />,
                  },
                ],
              }}
            >
              <MoreOutlined rev={undefined} />
            </Dropdown>
          ) : null}
        </p>
        <p>{user.role}</p>

        <div className="scenario-contact-item-contact">
          <a href={user.phone_number ? `tel:${user.phone_number}` : undefined}>
            <img src={ICON_PHONE} />
            <span>{user.phone_number || "-"}</span>
          </a>
          <Copy text={user.phone_number} />
        </div>

        <div className="scenario-contact-item-contact">
          <a href={user.email ? `mailto:${user.email}` : undefined}>
            <img src={ICON_EMAIL} />
            <span>{user.email || "-"}</span>
          </a>
          <Copy text={user.email} />
        </div>
      </div>
    </div>
  );
};

export default Item;
